import { notification } from "antd";

const openNotificationWithIcon = (type, title, mess) => {
    notification[type]({
        message: title,
        description: mess
    });
};

export default openNotificationWithIcon